import { ELianlianCardStatus, ICnapsCode, ILianAccApplySubmit, ILianDetail, IMyWalletsParam, IMyWalletDetail, IMyWalletListItem, IPreRecharge, IRechargeItem, IConsumptionItem } from '../types/lianlian';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getFileExt, getHostbaseUrl } from '@core/tools';
import { ILicenseSaveParam } from '../src/components/open-account/upload-license/type';
import { ILegalPersonSaveParam } from '../src/components/open-account/leagal-person/type';
import { IAccOpening, IBeneficiarySaveParam } from '../src/components';
import { getAccOpeningSaveParam } from './lianlian-utils';
import { IRechargeData } from '@core/main/types/alipay';

const hostUrl = getHostbaseUrl();

/**
 * 获取连连账户详细信息
 */
export async function queryLianDetail(lianId: number) {
  let data = {} as ILianDetail;

  try {
    const { code, context, message } = await Http.get<any>(
      `${hostUrl}/pay/agent/lian/detail`,
      { lianId },
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as ILianDetail;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 获取钱包账户列表
 */
export async function queryWallets(params = {} as IMyWalletsParam) {
  let total = 0;
  let data: IMyWalletListItem[] = [];

  try {
    const { code, context, message } = await Http.post<{ pageResult: { data: IMyWalletListItem[]; total: number } }>(
      `${hostUrl}/pay/agent-account/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const { pageResult } = context || {} as any;

      data = pageResult.data || [];
      total = pageResult.total || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 获取连连卡包状态
 */
export async function queryWalletInfo(type?: ELianlianCardStatus) {
  let data = {} as IMyWalletDetail;
  let resCode = '';
  let errorMessage = '';

  try {
    const { code, context, message } = await Http.post<any>(
      `${hostUrl}/pay/agent-account/page`,
      { type },
    );

    resCode = code;

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as any;

      delete res.pageResult;

      data = { ...res };
    } else {
      errorMessage = message || '服务器异常，请稍后再试~';
    }
  } catch (error) {
    errorMessage = getHttpErrorMessage(error);
  }

  return {
    data,
    code: resCode,
    errorMessage,
  };
}

/**
 * 查询支行&&大额行号列表
 */
export async function queryCnapsCodes(param?: {
  brabankName: string;
  bankCode: string;
  cityCode: string;
}) {
  let items: Array<ICnapsCode> = [];

  try {
    const { code, context, message } = await Http.post<ICnapsCode[]>(`${hostUrl}/pay/lian/disburse/queryCnapsCode`, param);

    if (code === EAxiosResponseCode.Succeed) {
      items = context || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return items;
}

/**
 * 申请账户 - 上传营业执照信息保存
 */
export async function submitLicense(param: ILicenseSaveParam) {
  let lianId = '';

  param = JSON.parse(JSON.stringify(param)) as ILicenseSaveParam;

  try {
    const { code, context, message } = await Http.post<string>(
      `${hostUrl}/pay/agent/lian/save-business-license`,
      param,
    );

    if (code === EAxiosResponseCode.Succeed) {
      lianId = context || '';
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return Number(lianId);
}

/**
 * 申请账户 - 法人信息保存
 */
export async function submitLegalPerson(param: ILegalPersonSaveParam) {
  param = JSON.parse(JSON.stringify(param)) as ILegalPersonSaveParam;

  try {
    const { code, message } = await Http.post<void>(
      `${hostUrl}/pay/agent/lian/save-legal-info`,
      param,
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 申请账户 - 受益人信息保存
 */
export async function submitBeneficiary(param: IBeneficiarySaveParam) {
  param = JSON.parse(JSON.stringify(param)) as IBeneficiarySaveParam;

  param.uboList.forEach((v) => {
    if (v.idNoFrontUrl) {
      v.idNoFrontType = getFileExt(v.idNoFrontUrl);
      v.idNoBackType = getFileExt(v.idNoBackUrl);
    }
  });

  try {
    const { code, message } = await Http.post<void>(
      `${hostUrl}/pay/agent/lian/save-beneficiary`,
      param,
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 申请账户 - 开户绑卡信息保存
 */
export async function submitOpenparam(param: IAccOpening) {
  param = JSON.parse(JSON.stringify(param)) as IAccOpening;
  const p = getAccOpeningSaveParam(param as IAccOpening);

  try {
    const { code, message } = await Http.post<void>(
      `${hostUrl}/pay/agent/lian/save-binding-card`,
      p,
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 申请账户 - 提交
 */
export async function submitApplyLianLian(param: ILianAccApplySubmit) {
  param = JSON.parse(JSON.stringify(param)) as ILianAccApplySubmit;

  try {
    const { code, message } = await Http.post<void>(
      `${hostUrl}/pay/agent/lian/open-acct`,
      param,
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 提交时候发送验证短信
 */
export async function sendLianSmscode(regPhone: string, lianId: number) {
  try {
    const { code, message } = await Http.post<string>(
      `${hostUrl}/pay/agent/lian/phone-verify-code-apply`,
      {
        lianId,
        regPhone,
      },
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 空中分账 - 连连账户 - 提现
 */
export async function lianlianWithdraw(params) {

  let data = {};

  try {
    const { code, context, message } = await Http.post(`${hostUrl}/pay/agent/cash/withdraw`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context;

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return data;
}

/**
 * 空中分账 - 连连账户 - 二次分账
 */
export async function lianlianWithdrawWithCode(params) {

  let data = {};

  try {
    const { code, context, message } = await Http.post(`${hostUrl}/pay/agent/cash/withdraw-sms-validate`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context;

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return data;
}

/**
 * 空中分账 - 代理商钱包 - 预充值-阈值配置
 */
export async function updateAgentRecharge(params: IPreRecharge) {

  try {
    const { code, message } = await Http.get<IPreRecharge>(`${hostUrl}/pay/agent-account/pre-recharge`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 空中分账 - 连连账户 - 查询预充值账户金额
 */
export async function queryRechargeData() {
  let data = {} as IRechargeData;

  try {
    const { code, context, message } = await Http.get(`${hostUrl}/pay/advance-account/balance`, {});

    if (code === EAxiosResponseCode.Succeed) {
      const res = context;

      data = (res || {}) as IRechargeData;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 获取充值记录
 */
export async function queryRechargeList(id: number, page: number, size: number) {
  let total = 0;
  let data: IRechargeItem[] = [];

  try {
    const { code, context, message } = await Http.post<{ pageResult: { data: IRechargeItem[]; total: number } }>(
      `${hostUrl}/pay/yop/advance-payment-account/recharge-page`,
      {
        id,
        page,
        size,
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as any;

      data = res.data || [];
      total = res.total || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 获取消耗记录
 */
export async function queryConsumptionList(id: number, page: number, size: number) {
  let total = 0;
  let data: IConsumptionItem[] = [];

  try {
    const { code, context, message } = await Http.post<{ pageResult: { data: IConsumptionItem[]; total: number } }>(
      `${hostUrl}/pay/yop/advance-payment-account/purchase-page`,
      {
        id,
        page,
        size,
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as any;

      data = res.data || [];
      total = res.total || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}
